import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export class MessagesPaths {
  static messages = new EnhancedPath('/messages');
}

const messagesRoutesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: MessagesPaths.messages.path,
      component: lazyWithRetry(() => import('app/pages/messages')),
      exact: true,
      isAllowedWithoutRoles: true,
    },
  ],
};

export default messagesRoutesConfig;
